/**
 * Tracks a telium event
 * @param {object} eventData
 */
export const trackEvent = (eventData = {}) => {
  const track = window.TMS?.trackEvent;

  // adds to a microthread and executes next tick
  setTimeout(() => {
    track && track(eventData);
  }, 0);
};
